module.exports = __webpack_public_path__ + "static/media/china_paper_cups_getty_tablet.16e86caf.jpg";